import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { HeaderLogo } from '../common';
import UserDropdownMenu from './UserDropdownMenu';

/**
 * DashboardHeader Component
 * 
 * Main header for the dashboard page.
 * Contains:
 * - HAAT Hub logo
 * - User dropdown menu
 * 
 * Sticky positioning for always-visible navigation.
 * 
 * @example
 * <DashboardHeader />
 */
const DashboardHeader: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <HeaderLogo showText />

          {/* User Menu */}
          <UserDropdownMenu user={user} onLogout={logout} />
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
